import React, { useEffect, useRef, useState} from 'react';
import { WalletCards, MessageSquareShare, UsersRound, Loader, Save, X, SquarePen, Plus } from 'lucide-react';
import { can_visit, notify, numberWithCommas } from "../../../helpers";
import { Config } from '../../../Config';
import { patientRetentions, updatePatientRetentions } from '../../../services/audits';
import { Drawer } from 'vaul';
import Card from '../../Card';
import Grid from '../../Grid';
import Spacing from '../../Spacing';

export default function PatientRetentionModal({
  account_id,
  location_id,
  activeModal = false,
  setActiveModal = () => {}
}) {

  const [loadData, setLoadData] = useState(true);
  const [patientRetention, setPatientRetention] = useState([]);
  const [editPatientRetention, setEditPatientRetention] = useState(false);
  const [savePatientRetentionLoader, setSavePatientRetentionLoader] = useState(false);
  const [formData, setFormData] = useState({
    account_id: account_id,
    location_id: location_id,
    total_patients: 0,
    potential_revenue: 0,
    assuming_encounter: 0,
    every_encounter_amount: 0,
    practice_opportunities: []
  });
  const dropdownRef = useRef(null);

  useEffect(() => {
    getPatientRetention(account_id, location_id);
  }, [account_id, location_id]);

  const getPatientRetention = async (accountId, locationId) => {
    try {
      const response = await patientRetentions(accountId, locationId);

      if (response) {
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setPatientRetention(response?.data);
          setPrecisionFormData(response?.data);
          setLoadData(false);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ getPatientRetention ~ error:", error);
    }
  };

  const setPrecisionFormData = (data) => {
    setFormData({
      account_id: account_id,
      location_id: location_id,
      ...data,
      practice_opportunities: data.practice_opportunities.map(opportunity => ({
        ...opportunity
      }))
    });
  };

  const handleAddDataSource = () => {
    const newOpportunity = {
      data_source: "",
      patient: 0
    };

    setFormData((prevData) => ({
      ...prevData,
      practice_opportunities: [...prevData.practice_opportunities, newOpportunity]
    }));
  };

  const handleDeleteRecord = async (index) => {
    setFormData((prevData) => {
      const updatedOpportunities = prevData.practice_opportunities.filter((_, i) => i !== index);
      return {
        ...prevData,
        practice_opportunities: updatedOpportunities
      };
    });
  };

  const handleInputChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleOpportunityChange = (index, key, value) => {
    const updatedOpportunities = formData.practice_opportunities.map((opp, i) => 
      i === index ? { ...opp, [key]: value } : opp
    );

    setFormData((prevData) => ({
      ...prevData,
      practice_opportunities: updatedOpportunities
    }));
  };

  const handleCancelEdit = () => {
    setPrecisionFormData(patientRetention);
    setEditPatientRetention(false);
  };

  const updatePatientRetentionReport = async (e) => {
    e.preventDefault();
    setSavePatientRetentionLoader(true);

    try {
      const response = await updatePatientRetentions(formData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          if(response?.data?.status === 'success') {
            notify("success", response?.data?.message);
            await getPatientRetention(account_id, location_id);
            setEditPatientRetention(false);
          } else  {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 1);
      }
    } finally {
      setSavePatientRetentionLoader(false);
    }
  }

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">

              <div className="docpro_modal" style={{ backgroundColor: 'rgb(249, 249, 251)' }}>
                {loadData ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <>
                    <form onSubmit={updatePatientRetentionReport}>
                      <div className="docpro_page_heading_wrap audit_modal_heading">
                        <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
                          <i
                            className="docpro_white_color"
                            style={{ backgroundColor: "#00ba5d" }}
                          >
                            <MessageSquareShare width={18} height={18} />
                          </i>
                          Patient Retention
                        </h2>

                        <div className="docpro_page_heading_btns">
                          {can_visit('administrator') && (
                          !editPatientRetention ?
                            <button 
                              type="button"
                              className="docpro_bordered_btn" 
                              style={{ background: '#1578d5', borderRadius: '5px', color: '#ffffff' }}
                              onClick={()=>{setEditPatientRetention(true);}}
                            >
                              <SquarePen width={20} height={20} />
                              <span>Edit</span>
                            </button>
                          :
                            <div className="flex item-center docpro_grid_gap_10">
                              <button 
                                type="button"
                                className="docpro_bordered_btn" 
                                style={{ background: '#e5484d', borderRadius: '5px', color: '#ffffff' }}
                                onClick={handleCancelEdit}
                              >
                                <X width={20} height={20} />
                                <span>Cancel</span>
                              </button>
                              {editPatientRetention && (
                                <button
                                  type="submit"
                                  style={{ borderRadius: '4px' }}
                                  className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                                  disabled={savePatientRetentionLoader ? true : false}
                                >
                                  <Save width={18} height={18} />
                                  <span>Save</span>
                                  {savePatientRetentionLoader && (
                                    <span className="docpro_loading">
                                      <Loader width={20} height={20} />
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <Spacing lg="20" sm="20" />

                      <Grid variant="docpro_grid_gap_20 docpro_grid_col_3">
                        <div className="docpro_card docpro_card_md docpro_card_1">
                          <h3 className="docpro_fs_14 docpro_mb_0 docpro_sky_color">
                            <UsersRound /> 
                            Potential Return to Care
                          </h3>
                          <Spacing lg="5" sm="5" />
                          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                            {!editPatientRetention ? 
                              <>{patientRetention?.total_patients ? numberWithCommas(patientRetention?.total_patients) : 0}</>
                            :
                              <span className="docpro_signout_input">
                                <input
                                  type="text"
                                  className="docpro_fw_500"
                                  style={{ maxWidth: "150px" }}
                                  defaultValue={formData?.total_patients || 0}
                                  onChange={(e) => handleInputChange("total_patients", e.target.value)}
                                />
                              </span>
                            }
                          </p>
                        </div>
                        <div className="docpro_card docpro_card_md docpro_card_1">
                          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
                            <WalletCards /> 
                            Potential Revenue
                          </h3>
                          <Spacing lg="5" sm="5" />
                          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                            {!editPatientRetention ? 
                              <>${patientRetention?.potential_revenue ? numberWithCommas(patientRetention?.potential_revenue) : 0.00}</>
                            :
                              <span className="docpro_signout_input items-center">
                                $
                                <input
                                  type="text"
                                  className="docpro_fw_500"
                                  style={{ maxWidth: "150px" }}
                                  defaultValue={formData?.potential_revenue || 0}
                                  onChange={(e) => handleInputChange("potential_revenue", e.target.value)}
                                />
                              </span>
                            }
                          </p>
                        </div>
                      </Grid>
                      <Spacing lg="18" sm="18" />
                      <Card variant="docpro_card docpro_card_1">
                        <div className='flex items-center'>
                          <img src="/images/favicon.png" width={45} alt="Icon" className='mr-4' />
                          <ul className='docpro_mb_0 docpro_fs_16'>
                            <li>{Config?._AppName} provides you the list of non-returning patients.</li>
                            <Spacing lg="5" sm="5" />
                            <li>Using {Config?._AppName} platform, you could text or call these patients.</li>
                          </ul>
                        </div>
                      </Card>
                      <Spacing lg="22" sm="22" />
                      <div>
                        <h3 className='docpro_fs_20 docpro_mb_0 mb-1'>Practice opportunities</h3>
                        <p className='docpro_fs_14 docpro_mb_0 docpro_crimson_color flex items-center'>From Return to Care: (Assuming&nbsp;
                          {!editPatientRetention ? 
                            <>{patientRetention?.assuming_encounter ? patientRetention?.assuming_encounter : 0}</>
                          :
                            <span className="docpro_signout_input">
                              <input
                                type="text"
                                className="docpro_fw_500"
                                style={{ maxWidth: "30px", backgroundColor: "transparent" }}
                                name="assuming_encounter"
                                defaultValue={formData?.assuming_encounter || 0}
                                onChange={(e) => handleInputChange("assuming_encounter", e.target.value)}
                              />
                            </span>
                          }
                          &nbsp;Encounter / Patient and
                          ${!editPatientRetention ? 
                            <>{patientRetention?.every_encounter_amount ? patientRetention?.every_encounter_amount : 0.00}</>
                          :
                            <span className="docpro_signout_input">
                              <input
                                type="text"
                                className="docpro_fw_500"
                                style={{ maxWidth: "60px", backgroundColor: "transparent" }}
                                name="every_encounter_amount"
                                defaultValue={formData?.every_encounter_amount || 0}
                                onChange={(e) => handleInputChange("every_encounter_amount", e.target.value)}
                              />
                            </span>
                          }
                          &nbsp;for every encounter)
                        </p>
                      </div>
                      <Spacing lg="18" sm="18" />

                      <div className="docpro_data_table_wrap">
                        <div className="docpro_table_responsive" style={{ minHeight: "100px", paddingTop: "6px" }}>
                          <table className="docpro_mb_0 opportunity_table" style={{ height: "100%" }}>
                            <thead>
                              <tr>
                                {editPatientRetention && (
                                  <th style={{ width: '60px' }}></th>
                                )}
                                <th>Data Source</th>
                                <th>Number of Patients</th>
                                <th>Potential Revenue</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!loadData ? (
                                formData?.practice_opportunities?.length > 0 ? (
                                  formData?.practice_opportunities?.map((item, index) => (
                                    <tr key={index}>
                                      {editPatientRetention && (
                                        <td style={{ padding: 0 }}>
                                          <div className='flex items-center' style={{ justifyContent: "end" }}>
                                            {(index === formData?.practice_opportunities?.length - 1) ? (
                                              <div className="text-right">
                                                <button 
                                                  type="button"
                                                  onClick={handleAddDataSource} 
                                                  className="docpro_icon_btn docpro_fw_600 docpro_primary_color mr-1" 
                                                  style={{ borderRadius: '50%', height: '24px', width: '24px' }}
                                                >
                                                  <Plus width={16} height={16} />
                                                  <span className="docpro_tip">Add</span>
                                                </button>
                                              </div>
                                            ) : (
                                              <div style={{ minWidth: '35px' }}></div>
                                            )}
                                            {formData?.practice_opportunities?.length > 1 && (
                                              <div className="text-right">
                                                <button
                                                  type="button"
                                                  onClick={() => handleDeleteRecord(index)}
                                                  className="docpro_icon_btn docpro_red_color docpro_icon_btn_red "
                                                  style={{ borderRadius: '50%', height: '24px', width: '24px' }}
                                                >
                                                  <X width={16} height={16} />
                                                  <span className="docpro_tip">Remove</span>
                                                </button>
                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                      <td>
                                        {!editPatientRetention ? 
                                          <>{item?.data_source || ""}</>
                                        :
                                          <span className="docpro_signout_input">
                                            <input
                                              required
                                              type="text"
                                              className="docpro_fw_500"
                                              style={{ maxWidth: "100%" }}
                                              value={formData?.practice_opportunities[index]?.data_source || ""}
                                              onChange={(e) => handleOpportunityChange(index, "data_source", e.target.value)}
                                            />
                                          </span>
                                        }
                                      </td>
                                      <td>
                                        {!editPatientRetention ? 
                                          <>{numberWithCommas(item?.patient) || 0}</>
                                        :
                                          <span className="docpro_signout_input">
                                            <input
                                              required
                                              type="number"
                                              className="docpro_fw_500"
                                              style={{ maxWidth: "70px" }}
                                              value={formData?.practice_opportunities[index]?.patient || 0}
                                              onChange={(e) => handleOpportunityChange(index, "patient", parseFloat(e.target.value))}
                                              min="0"
                                            />
                                          </span>
                                        }
                                      </td>
                                      <td>
                                        {!editPatientRetention ? 
                                          <>${item?.patient ? numberWithCommas(item.patient * formData.every_encounter_amount) : 0}</>
                                        :
                                          formData?.practice_opportunities[index]?.patient ? <>${numberWithCommas(formData?.practice_opportunities[index]?.patient * formData.every_encounter_amount) || 0}</> : '$0'
                                        }
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td className="no_data" colSpan="3">
                                      No data available
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr>
                                  <td className="no_data" colSpan="3">
                                    Loading...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}